var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBooksStack = function SvgBooksStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191,
    height: 93,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "books-stack_svg__a",
    width: 191,
    height: 93,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.781.921h189.586v92.058H.781z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#books-stack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    stroke: "#FAFAFA",
    d: "M179.805 81.436H120.69v12.04h59.115zM182.014 67.954H123.12v12.04h58.894zM186.877 54.472h-58.894v12.04h58.894zM190.855 40.99h-58.894v12.04h58.894zM179.805 27.509H120.69v12.04h59.115zM175.385 14.027h-58.894v12.04h58.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    stroke: "#FAFAFA",
    d: "M109.518 81.426H50.579v12.05h58.939zM107.307 67.934h-59.16v12.05h59.16zM109.518 54.443H50.579v12.05h58.939zM115.49 40.95H56.551V53h58.939zM112.393 27.459H53.454v12.05h58.939zM105.98 13.967H47.041v12.05h58.939zM109.518.475H50.579v12.05h58.939z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.744,
    height: 57.348,
    x: 1.486,
    y: 35.666,
    fill: "#D9D9D9",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 6.883,
    y: 55.635,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 6.883,
    y: 67.105,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 6.883,
    y: 78.573,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 18.557,
    y: 55.634,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 18.557,
    y: 67.105,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 18.557,
    y: 78.573,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 30.225,
    y: 55.636,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 30.225,
    y: 67.106,
    fill: "#fff",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.602,
    height: 10.136,
    x: 30.225,
    y: 78.574,
    fill: "#169B62",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.208,
    height: 11.603,
    x: 4.754,
    y: 39.935,
    fill: "#848484",
    rx: 1
  }))));
};
export { SvgBooksStack as ReactComponent };
export default __webpack_public_path__ + "images/books-stack.svg";